export const MOBILE_TABLE_CARD_LIST_CLASSNAME =
	'p-md pt-0 sm:p-0 flex flex-col gap-y-md sm:block';
